var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightLong(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Arrow") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.64545 10.0943H13.7419L8.45717 15.379C8.03482 15.8014 8.03482 16.4945 8.45717 16.9168C8.87952 17.3392 9.56178 17.3392 9.98413 16.9168L17.1207 9.78022C17.5431 9.35787 17.5431 8.67561 17.1207 8.25326L9.99496 1.10582C9.57261 0.683475 8.89035 0.683475 8.468 1.10582C8.04565 1.52817 8.04565 2.21043 8.468 2.63278L13.7419 7.92838H1.64545C1.04983 7.92838 0.5625 8.41571 0.5625 9.01133C0.5625 9.60695 1.04983 10.0943 1.64545 10.0943Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightLong);
export default __webpack_public_path__ + "static/media/arrow-right-long.f830534cb26ec62b7d1ee3ccd27550e9.svg";
export { ForwardRef as ReactComponent };